import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';

export interface IImage {
  id: string;
  type: MESSAGES.IMAGE;
  src: string;
  rm: boolean;
  nodeId: string;
  avatar: boolean;
  role: ROLE.BOT;
}

export const createImage = (data): IImage => {
  return {
    id: data.id || uuid(),
    type: MESSAGES.IMAGE,
    src: data.src,
    rm: Boolean(data.rm),
    nodeId: data.nodeId,
    avatar: true,
    role: ROLE.BOT,
  };
};
